import { BalloonNotice, Button } from '@doda/io-react/common';
import { FC, MutableRefObject } from 'react';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import classNames from 'classnames';
import styles from './index.module.scss';

/**
 * Propsの定義
 * @param onClick 検索条件を保存する処理
 * @param isShowBalloon 検索条件を保存後に表示するバルーンのフラグ
 * @param balloonRef 検索条件を保存後に表示するバルーンのref
 */
interface Props {
  onClick: () => void;
  isShowBalloon: boolean;
  balloonRef: MutableRefObject<HTMLDivElement | null>;
}

/**
 * 求人検索トップ画面 検索条件を保存するボタン
 */
export const SavedButton: FC<Props> = ({
  onClick,
  isShowBalloon,
  balloonRef,
}) => {
  return (
    <div className={styles.jobSearchTop__savedBtnWrap}>
      <div
        className={classNames(styles.jobSearchTop__balloonWrap, {
          [styles['jobSearchTop__balloonWrap--show']]: isShowBalloon,
        })}
        ref={balloonRef}
      >
        <BalloonNotice
          left={0}
          top={0}
          tailY="bottom"
          width={232}
          show={isShowBalloon}
          className={styles.jobSearchTop__balloon}
        >
          <p className={styles.jobSearchTop__balloon__heading}>
            検索条件を保存しました
          </p>
          <p className={styles.jobSearchTop__balloon__text}>
            「保存条件一覧を見る」のリンクから、条件を確認することができます
          </p>
        </BalloonNotice>
      </div>
      <Button as="button" onClick={onClick} size="L" variant="outline_blue">
        検索条件を保存する
      </Button>
      <a
        href={DODA_SITE_URL.savedConditionList}
        className={styles.jobSearchTop__linkTextForConditionList}
      >
        保存条件一覧を見る
      </a>
    </div>
  );
};
